import { useCallback, useContext } from 'react';
import { CheckoutContext } from '../../context/CheckoutContext/context';
import { PAYMENT_GROUPS_PAGE_SIZE } from '../../constants/payments';

function useCheckoutPagination() {
  const { state, dispatch } = useContext(CheckoutContext);

  const { totalCount } = state;
  const totalPages = Math.ceil(totalCount / PAYMENT_GROUPS_PAGE_SIZE);

  const hasPrevious = state.page > 1;
  const hasNext = state.page < totalPages;

  const next = useCallback(() => {
    dispatch({
      type: 'SET_PAGE',
      payload: Math.min(totalPages, state.page + 1),
    });
  }, [dispatch, totalPages, state.page]);

  const previous = useCallback(() => {
    dispatch({ type: 'SET_PAGE', payload: Math.max(1, state.page - 1) });
  }, [state.page, dispatch]);

  const set = useCallback(
    (page: number) => {
      dispatch({
        type: 'SET_PAGE',
        payload: Math.max(1, Math.min(totalPages, page)),
      });
    },
    [dispatch, totalPages],
  );

  return {
    page: state.page,
    next,
    previous,
    set,
    hasPrevious,
    hasNext,
    totalCount,
  };
}

export default useCheckoutPagination;
